import { useAppScope } from "master";
import "../styles/emptyMessage.style.css";

export const NotificationEmptyMessage = ({
  heading,
  subHeading,
  image,
  onCancel,
}) => {
  const { isMWCD } = useAppScope();

  return (
    <div className="text-center d-flex flex-column justify-content-center align-items-center pb-5 pt-5">
      {image && (
        <div
          className={
            isMWCD
              ? "no-video-img d-flex justify-content-center align-items-center mb-4"
              : "empty-msg-icon rounded-1 rounded-circle d-flex justify-content-center align-items-center ms-auto me-auto mb-4"
          }
        >
          {image && <img src={image} alt="" className="no-video-img__img" />}
        </div>

      )}
      <h3 className={isMWCD ? "no-video-heading" : "mb-3 empty-msg-title"} >
        {heading}
      </h3>

      <p className="ms-auto me-auto empty-msg-description">{subHeading}</p>
      {onCancel && (
        <button className="task-action-btn empty-msg-action" onClick={onCancel}>
          Go back
        </button>
      )}
    </div>
  );
};
